import React from 'react';
import { Box, Typography } from '@mui/material';
import globalStyles from '../../global';
import { getResponsiveSize } from '../../utils/responsive';
import Footer from '../HomeComponent/Footer';
import LocationSlider from './location';
import Brand from '../HomeComponent/Brand';
import LocationBanner from '../countryComponent/LocationBanner';
import OurMission from './ourmission';
import Interested from "../countryComponent/interested";
import { useTranslation } from 'react-i18next';

const Nepal = () => {
  const { t } = useTranslation();

  return (
    <Box>
       <LocationBanner
        prefix={t("nepal.locationBanner.prefix")}
        location={t("nepal.locationBanner.location")}
        backgroundImage="NepalBanner.png"
      />
      <OurMission />
      <Box sx={styles.typography}>
        <Typography variant="h1" sx={styles.typograph}>
          {t('nepal.findNearestLaundromat')}
        </Typography>
      </Box>
      <LocationSlider />
      <Interested
        title={t('nepal.interested.title')}
        content={t('nepal.interested.content')}
        buttonText={t("nepal.interested.buttonText")}
      />
      <Box sx={styles.typography}>
        <Typography variant="h1" sx={styles.typograph}>
          {t('nepal.featuredIn')}
        </Typography>
      </Box>

      <Brand />

      <Footer />
    </Box>
  );
};

const styles = {
  LocationSlider: {
    padding: '50px',
  },
  typography: {
    marginTop: '30px',
    textAlign: 'center',
  },
  typograph: {
    color: globalStyles.colors.army_green,
    fontSize: { xs: getResponsiveSize(28), md: getResponsiveSize(45) },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: '10px',
  },
};

export default Nepal;